import React, { useState, useEffect } from 'react';
import { X } from 'lucide-react';
import { useLanguage } from '../i18n/LanguageContext';

export const RainbowRoomPopup = () => {
  const { t } = useLanguage();
  const [show, setShow] = useState(false);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (params.get('from') === 'rainbow-room') {
      setShow(true);
    }
  }, []);

  const scrollTo = (id) => {
    setShow(false);
    const el = document.getElementById(id);
    if (el) {
      setTimeout(() => el.scrollIntoView({ behavior: 'smooth', block: 'start' }), 100);
    }
  };

  if (!show) return null;

  return (
    <div
      className="fixed inset-0 z-[100] flex items-center justify-center bg-black/70 backdrop-blur-sm px-4"
      data-testid="rainbow-room-popup-backdrop"
      onClick={() => setShow(false)}
    >
      <div
        className="relative w-full max-w-md rounded-2xl bg-slate-900 border border-slate-700/50 p-6 shadow-2xl"
        data-testid="rainbow-room-popup"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          onClick={() => setShow(false)}
          data-testid="rainbow-room-popup-close"
          className="absolute top-4 right-4 text-slate-500 hover:text-white transition-colors"
        >
          <X className="w-5 h-5" />
        </button>
        <p className="text-sm text-slate-200 leading-relaxed pr-6">
          {t('rainbowRoomPopupText')}
        </p>
        <div className="mt-5 flex flex-col sm:flex-row gap-3">
          <button
            onClick={() => scrollTo('rainbow-room-feedback')}
            data-testid="rainbow-room-popup-feedback-btn"
            className="flex-1 rounded-full bg-gradient-to-r from-sky-400 to-indigo-400 px-4 py-2.5 text-sm font-semibold text-white hover:opacity-90 transition-opacity"
          >
            {t('rainbowRoomPopupFeedbackBtn')}
          </button>
          <button
            onClick={() => scrollTo('waitlist')}
            data-testid="rainbow-room-popup-waitlist-btn"
            className="flex-1 rounded-full bg-gradient-to-r from-pink-500 to-cyan-400 px-4 py-2.5 text-sm font-semibold text-white hover:opacity-90 transition-opacity"
          >
            {t('rainbowRoomPopupWaitlistBtn')}
          </button>
        </div>
      </div>
    </div>
  );
};
